module.exports = __webpack_public_path__ + "static/media/tick-active.4e35e7ec.svg";